var map = {
	"./symbol_0.png": 24596,
	"./symbol_1.png": 45725,
	"./symbol_10.png": 97385,
	"./symbol_11_free.png": 24251,
	"./symbol_11_normal.png": 9096,
	"./symbol_12_free.png": 10490,
	"./symbol_12_normal.png": 16925,
	"./symbol_13_free.png": 75941,
	"./symbol_13_normal.png": 82790,
	"./symbol_14_free.png": 58268,
	"./symbol_14_normal.png": 95843,
	"./symbol_15_free.png": 35767,
	"./symbol_15_normal.png": 75324,
	"./symbol_16_free.png": 9734,
	"./symbol_16_normal.png": 29761,
	"./symbol_17_free.png": 13889,
	"./symbol_17_normal.png": 83690,
	"./symbol_18_free.png": 48280,
	"./symbol_18_normal.png": 23591,
	"./symbol_19_free.png": 46211,
	"./symbol_19_normal.png": 73264,
	"./symbol_2.png": 61958,
	"./symbol_3.png": 69436,
	"./symbol_4.png": 51184,
	"./symbol_5.png": 66937,
	"./symbol_6.png": 52930,
	"./symbol_7.png": 16587,
	"./symbol_8.png": 36284,
	"./symbol_9.png": 53797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97199;